// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"DialogsCommon_dialogContent___D9Ed"};